import React from 'react'
import PropTypes from 'prop-types'
import MagicLinkTemplate from '../../templates/MagicLinkTemplate'

export const MagicLinkPage = props => {
  const { onClickBackToLogin, onSuccess, onError, abTests } = props
  return (
    <MagicLinkTemplate
      onSuccess={onSuccess}
      onError={onError}
      onClickBackToLogin={onClickBackToLogin}
      abTests={abTests}
    />
  )
}

MagicLinkPage.propTypes = {
  onClickBackToLogin: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
}
